import axios from "./request"

export default {
  async get() {
    return (await axios.get('/partners')).data
  }
}
